import { validateGridSearch } from "@/components/composite/data-grid";
import { createFileRoute } from "@tanstack/react-router";
import { FeaturesPage } from "./-features/features.page";

export const Route = createFileRoute("/warehouse/features/")({
  validateSearch: validateGridSearch,
  component: FeaturesPage,
});
